import React, { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import {
  Page,
  Inner,
  Kicker,
  Title,
  Text,
  Divider,
  StatusLine,
  PrimaryBtn,
  GhostBtn,
} from "./ConfirmedUserPageStyles";

export default function ConfirmedUserPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [ok, setOk] = useState(false);

  useEffect(() => {
    const status = searchParams.get("status");

    if (status === "success") {
      setOk(true);
      setLoading(false);
      return;
    }

    // orice altceva (error / lipsă parametru) -> pagina de eroare
    navigate("/confirmed-user-error", { replace: true });
  }, [searchParams, navigate]);

  return (
    <Page>
      <Inner>
        <Kicker>Ahava Cakes</Kicker>
        <Title>Cont confirmat</Title>
        <Text>Mulțumim. Ai intrat oficial în povestea Ahava.</Text>

        <Divider />

        {loading ? (
          <StatusLine>
            Confirmăm contul tău… <span aria-hidden>⏳</span>
          </StatusLine>
        ) : ok ? (
          <>
            <StatusLine $tone="success">
              Confirmare reușită <span aria-hidden>✓</span>
            </StatusLine>

            <Text>
              Te poți autentifica acum și ești gata să descoperi deserturile
              noastre.
            </Text>

            <div
              style={{
                marginTop: 18,
                display: "flex",
                gap: 10,
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <Link to="/login">
                <PrimaryBtn>Autentificare</PrimaryBtn>
              </Link>
              <Link to="/">
                <GhostBtn>Înapoi pe site</GhostBtn>
              </Link>
            </div>
          </>
        ) : null}
      </Inner>
    </Page>
  );
}
